import React from "react";
import { Link } from "react-router-dom";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSwiperArrows } from "../../lib/hooks/useSwiperArrows";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

// Nettere projectlijst (later makkelijk uitbreidbaar)
const projectList = [
  { img: "project_img01.png", alt: "Herstoffering van een klassieke leren stoel;" },
  { img: "project_img02.png", alt: "Volledige kantoorinrichting met maatwerk stoffering" },
  { img: "project_img03.png", alt: "Herstofferen van horecameubilair in duurzame stoffen" },
  { img: "project_img04.png", alt: "Restauratie en stoffering van antieke fauteuils" },

  
];

const ProjectArea = () => {
  const swiper_settings = {
    spaceBetween: 20,
    slidesPerView: 1.2,
    loop: true,
    autoplay: true,
    breakpoints: {
      500: { slidesPerView: 1.4, spaceBetween: 20 },
      768: { slidesPerView: 2.2, spaceBetween: 20 },
      992: { slidesPerView: 3, spaceBetween: 20 },
      1200: { slidesPerView: 3.4, spaceBetween: 20 },
      1500: { slidesPerView: 3.3, spaceBetween: 20 },
    },
  };

  const { sliderRef, toNext, toPrev } = useSwiperArrows();

  return (
    <section className="project-area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-4">
            <div className="project-content">
              <div className="section-title white-title mb-30">
                <span className="sub-title">Onze Projecten</span>
                <h2 className="title">
                  Vakmanschap in Meubelstoffering en Projectinrichting
                </h2>
              </div>
              <p>
                Bekijk enkele voorbeelden van ons vakmanschap in meubel- en projectstoffering. 
                Van klassieke herstofferingen tot volledige bedrijfsinrichtingen. 
                Kwaliteit, maatwerk en duurzaamheid staan bij ons centraal.
              </p>
              <div className="content-bottom">
                {/* <Link to="/projects" className="btn">
                  Bekijk Alle Projecten <span></span>
                </Link> */}
                <div className="project-nav">
                  <button className="swiper-button-prev" onClick={toPrev}></button>
                  <button className="swiper-button-next" onClick={toNext}></button>
                </div>
              </div>
            </div>
          </div> 

          <div className="col-xl-8">
            <div className="project-item-wrap">
              <div className="swiper-container project-active">
                <Swiper
                  {...swiper_settings}
                  onBeforeInit={(swiper) => {
                    sliderRef.current = swiper;
                  }}
                >
                  {projectList.map((project, index) => (
                    <SwiperSlide key={index}>
                      <div className="swiper-slide">
                        <div className="project-item">
                          <Link to="/about-us">
                            <img
                              src={`/img/project/${project.img}`}
                              alt={project.alt}
                            />
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="project-shape-wrap">
        <img
          src="/img/project/project_shape01.png"
          alt="Decoratief vormelement projectsectie"
          className="shape-one ribbonRotate"
        />
        <img
          src="/img/project/project_shape02.png"
          alt="Decoratief vormelement projectsectie"
          className="shape-two ribbonRotate"
        />
      </div>
    </section>
  );
};

export default ProjectArea;
